export default __webpack_public_path__ + "static/media/group_120_120.e9b31692.png";